<div class="home-form">
    <ng-container *ngIf="americanView; then awayTeamTemplate; else homeTeamTemplate" />
</div>

<div class="away-form">
    <ng-container *ngIf="americanView; then homeTeamTemplate; else awayTeamTemplate" />
</div>

<ng-template #homeTeamTemplate>
    <ms-form-indicator *ngIf="homeTeamHomeForm" [outcomes]="homeTeamHomeForm" />
    <ms-form-indicator *ngIf="overallHomeTeamForm" [outcomes]="overallHomeTeamForm" />
</ng-template>

<ng-template #awayTeamTemplate>
    <ms-form-indicator *ngIf="awayTeamAwayForm" [outcomes]="awayTeamAwayForm" />
    <ms-form-indicator *ngIf="overallAwayTeamForm" [outcomes]="overallAwayTeamForm" />
</ng-template>
